import type { AuditState } from '@/types/gmb';

interface NoticeContent {
  icon: string;
  tone: string;
  title: string;
  reason: string;
  next: string;
}

const NOTICES: Partial<Record<AuditState, NoticeContent>> = {
  'search-invalid': {
    icon: 'ri-error-warning-line',
    tone: 'border-accent-200 bg-accent-50 text-accent-900',
    title: '搜尋條件無法處理',
    reason: '輸入的店家名稱或地區無法用來查詢，可能是名稱過短或包含特殊字元。',
    next: '請調整店家名稱後再試一次，可加上城市或行政區讓結果更精準。',
  },
  'api-error': {
    icon: 'ri-plug-line',
    tone: 'border-rose-200 bg-rose-50 text-rose-800',
    title: '資料來源暫時無法連線',
    reason: '查詢服務目前沒有回應，可能短暫維護中或網路不穩，並非你的輸入有誤。',
    next: '請稍後再試一次，或改用更完整的店家名稱重新查詢；已保存的健診報告仍可正常查看。',
  },
  'quota-error': {
    icon: 'ri-hourglass-line',
    tone: 'border-accent-200 bg-accent-50 text-accent-900',
    title: '目前搜尋服務較繁忙',
    reason: '同時使用的人較多，暫時無法即時完成查詢。',
    next: '請稍等片刻後再試一次。',
  },
  'daily-limit': {
    icon: 'ri-calendar-check-line',
    tone: 'border-accent-200 bg-accent-50 text-accent-900',
    title: '今日健診服務使用量已達安全上限',
    reason:
      '為保護 Google 商家資料服務的穩定與成本，每日健診使用量設有安全上限，目前今日額度已用盡。',
    next: '請於明日（台灣時間）再重新操作，即可繼續健診。',
  },
};

export default function StateNotice({ state }: { state: AuditState }) {
  const notice = NOTICES[state];
  if (!notice) return null;

  return (
    <section className="ds-container pt-8">
      <div className={`flex items-start gap-4 rounded-2xl border p-5 md:p-6 ${notice.tone}`}>
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-background-50/80">
          <i className={`${notice.icon} text-xl`} />
        </span>
        <div className="min-w-0">
          <p className="text-base font-bold md:text-lg">{notice.title}</p>
          <p className="mt-1.5 text-base leading-relaxed opacity-90">{notice.reason}</p>
          <p className="mt-3 flex items-start gap-2 text-base font-medium">
            <i className="ri-arrow-right-circle-line mt-0.5 text-lg" />
            <span>{notice.next}</span>
          </p>
        </div>
      </div>
    </section>
  );
}